import { FactAlert } from './FactAlert';
import { messages } from '@/shared/constants/messages';
import { pluralize } from '@/shared/lib/format';
import type { LeadTimeWarning } from '@/shared/constants/projectSizes';

/**
 * O alerta de antecedência por porte (US-21), ao lado de "Data e Hora".
 *
 * **Mora em arquivo próprio porque tem dois consumidores** (decisão 36): o
 * documento, junto do fato, e `DecisionForm` no ramo `approve` — a última tela
 * antes do irreversível. Enquanto ele vivia dentro de `DecisionPanel`, mover o
 * alerta para o documento enfraqueceria a US-21, porque quem aprova sem rolar
 * até "Data e Local" nunca o veria.
 *
 * ⚠️ O `(política: 60)` que vinha depois da frase SAIU: era legenda do desenho
 * ASCII da spec, lida literalmente, e fazia o alerta repetir o mesmo número
 * duas vezes na mesma linha.
 */
export function LeadTimeAlert({ size, leadTimeDays }: LeadTimeWarning) {
  return (
    <FactAlert title={messages.form.leadTimeTitle}>
      Este é um projeto de {size.label} e faltam{' '}
      {leadTimeDays >= 0 ? pluralize(leadTimeDays, 'dia', 'dias') : 'zero dias (a data já passou)'}.
      A política da igreja pede {size.expectedLeadTimeDays} dias de antecedência. Você pode decidir
      assim mesmo.
    </FactAlert>
  );
}
